<template>
  <div>
    <custom-tree-table></custom-tree-table>

  </div>
</template>

<script>
import CustomTreeTable from "@/components/CustomTreeTable";
export default {
  name: "TestTreeTable",
  components:{CustomTreeTable}
}
</script>

<style scoped>

</style>